import { Tooltip } from '@nextui-org/react';
import React from 'react';
import styled from 'styled-components';

import ZIndexLayers from '../../services/ZIndexLayers';
import { ThemeProp } from '../../theme/Themes';
import { ExtendedTooltipProps } from '../TextTooltip/TextTooltip';

interface CustomTooltipProps extends ExtendedTooltipProps {
  content: React.ReactElement;
}

type StyledCustomTooltipProps = ThemeProp & CustomTooltipProps;

const StyledCustomTooltip = styled(Tooltip).attrs((props: StyledCustomTooltipProps) => ({
  ...props,
  css: {
    ...props.css,
    marginTop: props.$noMarginTop ? '0' : 'auto',
    background: props.background || props.theme.colors.layout.surface.default,
    padding: props.padding || '0.25rem',
    borderRadius: '5px',
    border: props.border || `1px solid ${props.theme.colors.neutrals.c100}`,
    boxShadow: props.theme.shadows.tooltips,
    '& .nextui-tooltip': {
      background: props.background || props.theme.colors.layout.surface.default,
      maxWidth: props.$maxWidth,
      minWidth: props.$minWidth,
    },
    zIndex: props.$zIndex || ZIndexLayers.popup,
  },
}))<StyledCustomTooltipProps>`
  min-width: 0%;
  flex-shrink: 0;
  max-width: 100%;
  ${(props: StyledCustomTooltipProps) => props.$showPointer && 'cursor: pointer'};
`;

const CustomTooltip = ({ children, placement, ...rest }: CustomTooltipProps) => {
  return (
    <StyledCustomTooltip placement={placement || 'top'} {...rest}>
      {children}
    </StyledCustomTooltip>
  );
};

export default CustomTooltip;
